import * as actionTypes from '../actions/beneficiaries';

const initialState = {
  list: [],
  loading: false
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_SUCCESS: {
      const list = action.payload.data.data
      .sort((a, b) => (b['BeneficiaryDemographicTags.count'] > a['BeneficiaryDemographicTags.count']) ? 1 : -1)
      .map(item => ({
        name: item['BeneficiaryDemographicTags.name'],
        id: item['BeneficiaryDemographicTags.id']
      }));
      return {
        ...state,
        loading: false,
        list
      };
    }
    case actionTypes.GET_ERROR:
      return {
        ...state,
        loading: false
      };
    default: {
      return state;
    }
  }
};

export default filterReducer;
